import { ObjectUtils } from "../utils/object.utils";

export interface EsriCredentialsLike {
  token: string;
  expires?: number;
  ssl?: boolean;
  userId?: string;
  server: string;
}

export interface AuthInfoLike {
  esriCredentials?: EsriCredentialsLike;
  accessToken?: string;
  expires?: Date;
  userId?: string;
  userName?: string;
  entityId?: string;
  roles?: RoleLike[];
  initialMapConfig?: InitialMapConfigLike;
}

export interface RoleLike {
  id: string;
  name: string;
  type: string;
}

export interface InitialMapConfigLike {
  center?: { latitude?: number; longitude?: number };
  scale?: number;
}

export class EsriCredentials implements EsriCredentialsLike {
  token: string;
  ssl?: boolean;
  userId?: string;
  server: string;
  expires?: number;

  constructor(obj?: Partial<EsriCredentialsLike>) {
    this.token = obj?.token;
    this.ssl = obj?.ssl;
    this.userId = obj?.userId;
    this.server = obj?.server;
    this.expires = obj?.expires;
  }

  isAuthenticated() {
    return !!(this.token && (this.expires ?? 0) > Date.now());
  }
}

export class AuthInfoModel implements AuthInfoLike {
  accessToken?: string;
  expires?: Date;
  esriCredentials?: EsriCredentials;
  userId?: string;
  userName?: string;
  entityId?: string;
  roles?: RoleLike[];
  initialMapConfig?: InitialMapConfigLike;

  constructor(obj?: Partial<AuthInfoLike>) {
    this.accessToken = obj?.accessToken;
    this.esriCredentials = !obj?.esriCredentials
      ? null
      : new EsriCredentials(obj.esriCredentials);

    this.expires = !obj?.expires ? null : new Date(obj.expires);
    this.userId = obj?.userId;
    this.userName = obj?.userName;
    this.entityId = obj?.entityId;
    this.roles = ObjectUtils.clone(obj?.roles) ?? [];

    this.initialMapConfig = !obj?.initialMapConfig
      ? null
      : Object.assign({}, obj.initialMapConfig);
  }

  isAuthenticated() {
    return !!(this.accessToken && (this.expires?.getTime() ?? 0) > Date.now());
  }
}
